export const currencyService = {
  formatNumberToCurrency(number: number): string {
    return `${number.toLocaleString('de-DE', { minimumFractionDigits: 2 })} €`;
  }
};
